if (!customElements.get("model-element")) {
  customElements.define(
    "model-element",
    class ModelElement extends HTMLElement {
      constructor() {
        super();
        this.initialize();
        this.showModelBound = this.showModel.bind(this);
        this.closeButtonBound = this.closeButton.bind(this);
      }

      connectedCallback() {
        this.modelBtn.addEventListener("click", this.showModelBound);
        this.closeBtn?.addEventListener("click", this.closeButtonBound);
      }

      disconnectedCallback() {
        this.modelBtn.removeEventListener("click", this.showModelBound);
        this.closeBtn.removeEventListener("click", this.closeButtonBound);
      }

      initialize() {
        const els = this.querySelectorAll('[data-model="true"]');
        this.elsArr = Array.from(els);
        this.ul = this.querySelectorAll("ul");
        this.modelBtn = this.querySelector(".model-btn");

        this.modelContainer = document.querySelector(".model-container");
        this.modelWrapper = this.modelContainer?.querySelector(".model");
        this.closeBtn = this.modelContainer?.querySelector(".close-btn");
        this.iframe = this.querySelector("iframe");
      }

      showModel(event) {
        const el = event.target.closest('[data-model="true"]');
        window.scrollTo({ top: 0 });
        document.body.style.overflow = "hidden";

        const modelViewer = el?.querySelector("model-viewer") || this.iframe;
        this.modelWrapper?.appendChild(modelViewer.cloneNode(true));
        this.modelContainer?.classList.remove("hidden");
      }

      closeButton() {
        document.body.style.overflow = "auto";
        this.modelContainer?.classList.add("hidden");
        this.modelWrapper.innerHTML = "";
      }
    },
  );
}
